export const useFocusNext = (elem: any) => {
  const currentIndex = Array.from(elem.form.elements).indexOf(elem)

  if (currentIndex < elem.form.elements.length - 1) {
    elem.form.elements.item(currentIndex + 1).focus()
  }
}
